import { PropsCell } from 'src/components/common/Table/TableHeader';

export const headCellsLoans: PropsCell[] = [
  {
    id: 'loan_id',
    numeric: false,
    disablePadding: false,
    label: 'Préstamo ID',
  },
  {
    id: 'users_name',
    numeric: false,
    disablePadding: false,
    label: 'Usuario (ID)',
  },
  {
    id: 'created',
    numeric: false,
    disablePadding: false,
    label: 'Fecha de devolución',
  },
];

export const fieldsFilterList = [
  { key: 'loan_id', name: 'Préstamo ID' },
  { key: 'users_id', name: 'ID de usuario' },
  { key: 'created', name: 'Fecha de devolución' },
];

export const valuesEstatus = [
  { key: '1', name: 'Activo' },
  { key: '2', name: 'Concluido / devuelto' },
  { key: '3', name: 'Eliminado' },
];
